module.exports = __webpack_public_path__ + "img/spirit_small_4.170e5be2.png";